import { render } from "./HeroListShow.vue?vue&type=template&id=f6a8539c&scoped=true"
import script from "./HeroListShow.vue?vue&type=script&lang=js"
export * from "./HeroListShow.vue?vue&type=script&lang=js"

import "./HeroListShow.vue?vue&type=style&index=0&id=f6a8539c&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a8539c"]])

export default __exports__